export enum PositionErrors {
  PermissionDenied = 1,
  PositionUnavailable = 2,
}
